<template>
    <div v-show="value" class="common-confirm" :style="{'z-index':zIndex}">
        <div class="confirm-module" :style="{'width': `${width}`}">
            <div v-if="isCustomTitle" class="confirm-module-title"><slot name="title"></slot></div>
            <div v-else class="confirm-module-title">{{title}}</div>
            <div class="confirm-module-content"><slot name="content"></slot></div>
            <template v-if="isButton">
              <div class="confirm-module-btn btn-cancel" @click="cancelClick">{{cancelButtonText}}</div>
              <div class="confirm-module-btn" @click="confirmClick">{{confirmButtonText}}</div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CommonConfirm',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '250px'
      },
      zIndex: {
        type: Number,
        default: 10500
      },
      title: {
        type: String,
        default: "温馨提示"
      },
      isButton: {
        type: Boolean,
        default: true
      },
      cancelButtonText: {
        type: String,
        default: "取消"
      },
      confirmButtonText: {
        type: String,
        default: "确定"
      },
      isCustomTitle: {
        type: Boolean,
        default: false
      }
    },
    data () {
        return  {
        }
    },
    methods: {
        confirmClick () {
            this.$emit("confirm", true)
        },
        cancelClick() {
            this.$emit("cancel", false)
        }
    }
}
</script>

<style scoped lang="less">
.common-confirm {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10500;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);

  & .confirm-module {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate3d(-50%, -50%, 0);
    -moz-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    width: 250px;
    padding-top: 24px;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
  }

  & .confirm-module-title {
    padding-bottom: 15px;
    font-size: 18px;
    line-height: 1;
    color: #FEBC10;
    text-align: center;
  }

  & .confirm-module-content {
    padding: 0 15px 15px;
    font-size: 12px;
    line-height: 18px;
    color: #333;
    word-break: break-all;
  }

  & .confirm-module-btn {
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    text-align: center;
    background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
    background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
    background: -moz-linear-gradient(left, #FEBC10, #FAD961);
    background: -o-linear-gradient(left, #FEBC10, #FAD961);
    background: linear-gradient(to right, #FEBC10, #FAD961);
    border-bottom-right-radius: 5px;
    display: inline-block;
    width: 50%;
  }

  & .confirm-module-btn.btn-cancel {
    background: #F6F7F8;
    border-bottom-left-radius: 5px;
  }
}
</style>
